import { FeatureAppConfig, useFeatureAppEnvironment } from 'src/feature-app';

export function useFeatureAppConfig(): FeatureAppConfig {
  const { config } = useFeatureAppEnvironment();

  return config || {};
}
